import { render } from "./VideoSection.vue?vue&type=template&id=648eb7c7&scoped=true"
const script = {}

import "./VideoSection.vue?vue&type=style&index=0&id=648eb7c7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-648eb7c7"]])

export default __exports__